import { createRoot } from 'react-dom/client';
import App from './App';
import { createBrowserOcrEngine } from './core/ocrWeb';
import { createPdfRenderer } from './core/render';
import { runSplitPipeline } from './core/pipeline';
import './styles.css';

// Debug hook used by the automated browser tests (window.__SPS_DEBUG__).
if (typeof window !== 'undefined') {
  (window as unknown as Record<string, unknown>).__SPS_DEBUG__ = {
    createBrowserOcrEngine,
    createPdfRenderer,
    runSplitPipeline,
  };
}

createRoot(document.getElementById('root')!).render(<App />);
